export const getOnlyNumbers = (str: string) => str.replace(/[^0-9]+/g, '');
